module.exports = __webpack_public_path__ + "media/luxury-2026/billiard-room-a90de5a2.jpg";